<script setup lang="ts">
import { type VNode } from 'vue';

import { buttonVariants } from '@/kasten-components/components/KaButton/button-variants';
import { cnMerge } from '@/utils/utils.js';

defineSlots<{
  left(): VNode;
  default(): VNode;
  right(): VNode;
}>();

import type { InternalLinkProps } from './types';
export type { InternalLinkProps } from './types';

const props = withDefaults(defineProps<InternalLinkProps>(), {
  variant: 'link',
  danger: false,
  useFocusVisible: true,
  class: undefined,
  left: undefined,
  right: undefined,
});
</script>

<template>
  <a
    :class="
      cnMerge(
        buttonVariants({
          variant: props.variant,
          size: 'base',
          isDanger: props.danger,
          isIcon: false,
          isLoading: false,
          useFocusVisible: props.useFocusVisible,
        }),
        props.class,
      )
    "
  >
    <span
      v-if="$slots.left || props.left"
      aria-hidden="true"
      class="mr-1 flex-shrink-0 flex-grow-0 text-current [&>svg]:block"
    >
      <slot name="left">
        <component
          :is="props.left.icon"
          v-if="props.left"
          :class="cnMerge('size-4', props.left.classes)"
          tabindex="-1"
        />
      </slot>
    </span>

    <slot />

    <span
      v-if="$slots.right || props.right"
      aria-hidden="true"
      class="ml-1 flex-shrink-0 flex-grow-0 text-current [&>svg]:block"
    >
      <slot name="right">
        <component
          :is="props.right.icon"
          v-if="props.right"
          :class="cnMerge('size-4', props.right.classes)"
          tabindex="-1"
        />
      </slot>
    </span>
  </a>
</template>
